/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Typography } from 'antd'
import { fetchSystemPermissionsList } from '@/redux/use/systemPermissionSlice'
import {
  buildPermissionAntTreeData,
  getRolePermissionCheckedKeysWithAncestors
} from '@/utils/rolePermissionTree'
import { PermissionTreeField } from './RolePermissionTreeField'

const { Text } = Typography

const mapStateToProps = (state) => ({
  permissionsList: state.use.systemPermission.list,
  permissionsFetching: state.use.systemPermission.fetching
})

const mapDispatchToProps = {
  fetchSystemPermissionsList
}

/**
 * 仅为已有角色分配权限（由 WrappedDrawer 注入 form ref）
 */
class RoleAssignPermissionForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    permissionsList: PropTypes.array,
    permissionsFetching: PropTypes.bool,
    fetchSystemPermissionsList: PropTypes.func,
    /** 当前行角色数据，用于回填已选权限 */
    record: PropTypes.object
  }

  componentDidMount() {
    const { permissionsList, fetchSystemPermissionsList: load, record } = this.props
    const afterLoad = () => {
      this.applyInitial()
    }
    if (!permissionsList || permissionsList.length === 0) {
      load().finally(afterLoad)
    } else {
      afterLoad()
    }
  }

  applyInitial = () => {
    const { record, form, permissionsList } = this.props
    if (!record || !form?.current) return
    const fullTree = buildPermissionAntTreeData(permissionsList || [])
    form.current.setFieldsValue({
      permissionIds: getRolePermissionCheckedKeysWithAncestors(record, fullTree)
    })
  }

  getFullTreeData = () => {
    const { permissionsList } = this.props
    return buildPermissionAntTreeData(permissionsList || [])
  }

  render() {
    const { form, permissionsFetching, record } = this.props
    const fullTree = this.getFullTreeData()

    return (
      <Form
        ref={form}
        layout="vertical"
        initialValues={{ permissionIds: [] }}
        style={{ width: '100%', maxWidth: '100%' }}
      >
        {record ? (
          <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
            角色：{record.name ?? '—'}（{record.code ?? '—'}）
          </Text>
        ) : null}
        <Form.Item
          label="权限"
          name="permissionIds"
          extra={
            <Text type="secondary" style={{ fontSize: 12 }}>
              仅最末级可勾选；分类名前的灯泡表示其下已有选中项。
            </Text>
          }
          style={{ marginBottom: 0 }}
        >
          <PermissionTreeField
            fullTreeData={fullTree}
            loading={permissionsFetching}
            contentHeight
          />
        </Form.Item>
      </Form>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleAssignPermissionForm)
